import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ContentChildren,
  Directive, forwardRef, Inject,
  Input,
  OnInit, QueryList,
  ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';

let id = 0;

@Component({
  selector: 'mcrai-input[type=radio]',
  template: `<label class="mcrai-input__label" [class.mcrai-input__label--active]="checked" [attr.for]="id">
  <input
    class="mcrai-input__radio"
    [id]="id"
    [name]="name"
    (click)="onClick()"
    [disabled]="isDisabled()"
    [checked]="checked"
    type="radio">
  <div class="mcrai-input__circle"></div>
  <div class="mcrai-input__text">
    <ng-content></ng-content>
  </div>
</label>
`,
  styles: [`.mcrai-input__label{display:flex;align-items:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[disabled]>.mcrai-input__label{opacity:.4;cursor:default}.mcrai-input__radio{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.mcrai-input__circle{position:relative;top:0;left:0;height:20px;width:20px;border:2px solid;margin-right:10px;border-radius:50%}.mcrai-input__circle:after{content:'';position:absolute;display:none;left:0;top:0;bottom:0;right:0;margin:auto;width:10px;height:10px;border-radius:50%}.mcrai-input__radio:checked~.mcrai-input__circle:after{display:block}.mcrai-input__text{flex:1}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-input]': 'true',
    '[class.mcrai-input--radio]': 'true'
  }
})
export class McRAIRadio implements OnInit {
  private _id = `mcrai-input--radio-${++id}`;
  get id() {
    return this._id;
  }

  private _disabled: undefined | null | boolean;
  @Input() set disabled(value: undefined | null | boolean) {
    this._disabled = value;
  }

  private _value: any;
  @Input() set value(value: any) {
    this._value = value;
  }
  get value(): any {
    return this._value;
  }

  private _name: string;
  set name(value: string) {
    this._name = value;
  }
  get name(): string {
    return this._name;
  }

  private _checked = false;
  set checked(value: boolean) {
    this._checked = value;
    this._changeDetectorRef.markForCheck();
  }
  get checked(): boolean {
    return this._checked;
  }

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(forwardRef(() => McRAIRadioGroup)) private _radioGroup: McRAIRadioGroup,
  ) { }

  ngOnInit() {
    if (this._radioGroup.value === this._value) {
      this.checked = true;
    }

    this.name = this._radioGroup.name;
  }

  public onClick(): void {
    this._radioGroup.value = this.value;
    this.checked = true;
  }

  public isDisabled(): boolean {
    return !this._disabled && typeof this._disabled !== 'undefined';
  }

}

@Directive({
  selector: 'mcrai-radio-group',
  host: {
    '[class.mcrai-radio-group]': 'true'
  }
})
export class McRAIRadioGroup implements OnInit {
  @ContentChildren(McRAIRadio) private _radios: QueryList<McRAIRadio>;

  private _name = `mcrai-radio-group-${ ++id }`;
  get name(): string {
    return this._name;
  }

  private _control: FormControl;
  @Input() set control(value: FormControl) {
    this._control = value;
  }

  set value(value: any) {
    this._control.setValue(value);
    this._radios.forEach(radio => radio.checked = false);
  }
  get value(): any {
    return this._control.value;
  }

  constructor() { }

  ngOnInit() { }

}
